"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastActionSeparatorStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colors = require("../../../constants/colors");
var _spacing = require("../../../constants/spacing");
const darkSeparatorColor = (0, _colors.toRgba)(_colors.neutralDark40, 0.12);
const backgroundColors = {
  error: (0, _colors.toRgba)(_colors.neutralLight40, 0.2),
  info: darkSeparatorColor,
  success: darkSeparatorColor,
  warning: darkSeparatorColor
};
const ToastActionSeparatorStyled = (0, _styled.default)("div")`
    background-color: ${_ref => {
  let {
    ToastType
  } = _ref;
  return backgroundColors[ToastType];
}};
    width: 2px;
    height: ${_spacing.sizes.large}px;

    margin: 0 ${_spacing.sizes.xSmall}px;
`;
exports.ToastActionSeparatorStyled = ToastActionSeparatorStyled;
//# sourceMappingURL=ToastActionSeparatorStyled.js.map